import ozInterestsShowcase from './oz-interests-showcase.vue'

export default ozInterestsShowcase
